import { useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useParams } from 'react-router-dom'
import FullView from '../../components/5templates/FullView'
import useDynamicTabs from './useDynamicTabs'
import TabTemplate from '../../components/5templates/TabTemplate'
import { useSelector } from '../../common/redux.Interface.Component'
import { useDispatch } from '../../common/redux.Interface.Component'
import React, { useEffect } from 'react'
import LoaderBackdrop from '../../components/2compounds/LoaderBackdrop'
import {
  AccountDetail,
  ImageSlider,
  ServiceList
} from '../../components/3modules/TabWidgets/index'
import DeleteConfirmationModal from '../../components/1elements/Modals/DeleteConfirmationModal'
import NoData from '../../components/2compounds/NoData'
import { GlobalContext } from '../../services/context/DataContext'
import { providerDataFetch } from './reducers/actions'

const ProviderTabs = () => {
  const { tabName } = useParams()
  const loading = useSelector(state => state.tabs.loading)
  const dispatch = useDispatch()

  const {
    isEditMode,
    setIsEditMode,
    layoutData,
    reorderCards,
    isLoading,
    snackbar,
    setSnackbar,
    handleSave,
    handleCancel,
    resetAllToDefault,
    resetToDefault,
    handleSaveAdmin,
    handleCancelAdmin,
    widgetSwitcher,
    selectedLoc,
    reorderFields,
    toggleIsHidden,
    updateFieldLabel,
    updateDataType,
    updateCardLabel,
    isCardDirty,
    toggleDeleteConfirmationModal,
    deleteField,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    updateCardLabelMultipleColumns,
    toggleIsHiddenCard,
    isSaveModalOpen,
    setIsSaveModalOpen,
    toggleUpdateConfirmationModal,
    hasNoData,
    layoutDefaultData
  } = useDynamicTabs(true)

  useEffect(() => {
    dispatch(
      providerDataFetch({
        tabName
      })
    )
  }, [tabName, dispatch])

  const classes = useStyles({ isLoading })
  const { servicesCategorizedByServiceTypeContext } = useContext(GlobalContext)
  const [servicesCategorizedByServiceType] =
    servicesCategorizedByServiceTypeContext

  if (hasNoData || loading) {
    return (
      <FullView disabled={true}>
        <NoData />
      </FullView>
    )
  }

  return (
    <FullView disabled={true}>
      <LoaderBackdrop open={isLoading} className={classes.loader} />
      <TabTemplate
        className={classes.mainDiv}
        handleCancel={handleCancel}
        handleCancelAdmin={handleCancelAdmin}
        handleSave={handleSave}
        handleSaveAdmin={handleSaveAdmin}
        handleResetAllToDefault={resetAllToDefault}
        toggleIsHidden={toggleIsHidden}
        updateFieldLabel={updateFieldLabel}
        updateDataType={updateDataType}
        admin={true}
        snackbar={snackbar}
        setSnackbar={setSnackbar}
        widgetSwitcher={widgetSwitcher}
        tabTitle={tabName === 'tab0' && selectedLoc}
        layoutData={layoutData}
        reorderCards={reorderCards}
        toggleUpdateConfirmationModal={toggleUpdateConfirmationModal}
        isSaveModalOpen={isSaveModalOpen}
        setIsSaveModalOpen={setIsSaveModalOpen}
        editMode={isEditMode}
        setEditMode={setIsEditMode}
        initialValues={layoutData}
      >
        {formikProps => {
          return (
            <>
              {(tabName === 'tab1' ||
                tabName === 'tab2' ||
                tabName === 'tab3') && (
                <div className={classes.fixedListSection}>
                  {layoutData.map((data, index) => {
                    if (
                      ((data.type === 'Service List' ||
                        data.type === 'Contact List') &&
                        servicesCategorizedByServiceType[data.label]) ||
                      data.type === 'Service List' ||
                      data.type === 'Contact List'
                    ) {
                      const props = {
                        admin: true,
                        index,
                        editMode: isEditMode,
                        data,
                        formikProps,
                        key: data.cardId,
                        updateCardLabel,
                        className: classes.fixedServiceListPosition,
                        layoutDefaultData
                      }
                      return <ServiceList {...props} />
                    }
                    return ''
                  })}
                </div>
              )}

              {layoutData.map((data, index) => {
                if (data.type === 'Image Slider') {
                  const props = {
                    admin: true,
                    index,
                    editMode: isEditMode,
                    data,
                    formikProps,
                    key: data.cardId,
                    resetToDefault,
                    className: classes.fixedImageSliderPosition
                  }
                  return <ImageSlider {...props} />
                }

                if (data.type === 'Account Detail') {
                  const props = {
                    admin: true,
                    index,
                    editMode: isEditMode,
                    data,
                    formikProps,
                    key: data.cardId,
                    resetToDefault,
                    className: classes.fixedAccountDetailPosition
                  }
                  return <AccountDetail {...props} />
                }

                if (data) {
                  return widgetSwitcher({
                    data,
                    admin: true,
                    index,
                    formikProps,
                    resetToDefault,
                    reorderFields,
                    toggleIsHidden,
                    updateFieldLabel,
                    updateDataType,
                    updateCardLabel,
                    isCardDirty,
                    toggleDeleteConfirmationModal,
                    updateCardLabelMultipleColumns,
                    toggleIsHiddenCard
                  })
                }
                return ''
              })}
            </>
          )
        }}
      </TabTemplate>
      <DeleteConfirmationModal
        open={isDeleteModalOpen}
        setOpen={setIsDeleteModalOpen}
        onSubmit={deleteField}
      />
    </FullView>
  )
}

export default ProviderTabs

const useStyles = makeStyles(() => ({
  root: {},
  spacer: {},
  fixedImageSliderPosition: {
    gridColumn: '-5/-1',
    gridRow: '1/9',
    maxWidth: '100%',
    maxHeight: '100%',
    overflow: 'hidden'
  },
  fixedAccountDetailPosition: {
    gridColumn: '1/6',
    gridRow: '1/5',
    maxWidth: '100%',
    maxHeight: '100%',
    overflow: 'hidden'
  },
  fixedServiceListPosition: {
    maxWidth: '100%'
  },
  fixedListSection: {
    gridColumn: '1/5',
    gridRow: '1/-1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    overflowY: 'auto'
  }
}))
